import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeTestimony = () => {
  const [TestimonyTopUser, setTestimonyTopUser] = useState([]);
  const [TestimonyUser, setTestimonyUser] = useState([]);
  const navigate = useNavigate();

  //   Testimony top api
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://admin.gosaviadvanceddentalclinic.com/api/gettestimonytop"
      );
      setTestimonyTopUser(response.data);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://admin.gosaviadvanceddentalclinic.com/api/gettestimony"
      );
      setTestimonyUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deletetestimony/${userId}`);

      setTestimonyUser((prevUsers) =>
        prevUsers.filter((user) => user.id !== userId)
      );

      toast.error("Data Deleted Successfully!");
      navigate("/Testimony");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          {TestimonyTopUser.map((user) => {
            return (
              <div>
                <h3>
                  {user.heading}{" "}
                  <Link to={`/Testimony-header-edit/` + user.id}>
                    {" "}
                    <i className="fa-regular fa-pen-to-square action-btn"></i>
                  </Link>
                </h3>
                <p dangerouslySetInnerHTML={{ __html: user.para }}></p>
              </div>
            );
          })}
          <Link to="/Testimony-add">
            <button className="Banner-button">Add</button>
          </Link>
          <div className="row table-home">
            <table>
              <thead>
                <tr>
                  <th className="col-lg-1">Sr.No</th>
                  <th className="col-lg-2">Image</th>
                  <th className="col-lg-4">Description</th>
                  <th className="col-lg-2">Name</th>
                  <th className="col-lg-2">Action</th>
                </tr>
              </thead>
              <tbody>
                {TestimonyUser.map((user, index) => {
                  return (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>
                        {" "}
                        <img
                          src={user.testimonyimage}
                          alt="Testimony"
                          style={{ width: "150px", height: "100px" }}
                        />
                      </td>
                      <td>
                        <p
                          dangerouslySetInnerHTML={{ __html: user.description }}
                        ></p>
                      </td>
                      <td>{user.name}</td>
                      <td>
                        <Link to={`/Testimony-view/` + user.id}>
                          <i
                            title="View"
                            className="fa-regular fa-eye action-btn"
                            style={{ color: "blue" }}
                          ></i>
                        </Link>
                        <Link to={`/Testimony-edit/` + user.id}>
                          <i className="fa-regular fa-pen-to-square action-btn"></i>
                        </Link>
                        <span onClick={() => deleteUser(user.id)}>
                          <i
                            title="Delete"
                            className="fa-solid fa-trash-can action-btn"
                            style={{ color: "red" }}
                          ></i>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export const TestimonyAdd = () => {
  const [TestimonyData, setTestimonyData] = useState({
    name: "",
    description: "",
    testimonyimage: null,
  });
  const [previewImage, setPreviewImage] = useState("");
  const navigate = useNavigate();

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setTestimonyData((prev) => ({ ...prev, [name]: value }));
  };

  const imageHandler = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/webp",
      ];
      const maxSize = 2 * 1024 * 1024; // 2MB

      // Validate type
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }

      // Validate size
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }

      // Optional: Dimension check
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = () => {
        if (img.width > 800 || img.height > 800) {
          toast.error("Image dimensions should not exceed 800x800.");
          URL.revokeObjectURL(objectUrl);
          return;
        }

        setTestimonyData((prev) => ({ ...prev, testimonyimage: file }));
        setPreviewImage(objectUrl); // Show preview
      };
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (
      !TestimonyData.name ||
      !TestimonyData.description ||
      !TestimonyData.testimonyimage
    ) {
      toast.error("All fields, including an image, are required!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", TestimonyData.name);
      formData.append("description", TestimonyData.description);
      formData.append("testimonyimage", TestimonyData.testimonyimage);

      await axios.post("https://admin.gosaviadvanceddentalclinic.com/api/createtestimony", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Data added successfully!");
      navigate("/Testimony"); // Redirect after success
    } catch (error) {
      console.error("Error adding Testimony:", error);
      toast.error("Failed to add Testimony!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" />
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/Testimony">
              <i className="fa-solid fa-xmark"></i>
            </Link>
            <h3>Add Testimony Data</h3>
            <form
              className="row"
              onSubmit={submitForm}
              encType="multipart/form-data"
            >
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="testimonyimage">Upload Testimony Image</label>
                <input
                  type="file"
                  id="testimonyimage"
                  name="testimonyimage"
                  accept="image/*"
                  onChange={imageHandler}
                />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "70%",
                      height: "350px",
                      borderRadius: "8px",
                      display: "block",
                      margin: "10px auto",
                    }}
                  />
                )}
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="description">Description</label>
                <textarea
                  onChange={inputHandler}
                  value={TestimonyData.description}
                  id="description"
                  name="description"
                  placeholder="Enter Description"
                  rows="4"
                ></textarea>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={TestimonyData.name}
                  id="name"
                  name="name"
                  placeholder="Enter Name"
                />
              </div>

              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export const HomeTestimonyEdit = () => {
  const [Testimonyuser, setTestimonyUser] = useState({
    name: "",
    description: "",
    testimonyimage: "",
  });
  const [previewImage, setPreviewImage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [editorLoaded, setEditorLoaded] = useState(false);

  // Load CKEditor
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.ckeditor.com/4.21.0/standard/ckeditor.js";
    script.async = true;
    script.onload = () => setEditorLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (window.CKEDITOR) {
        Object.keys(window.CKEDITOR.instances).forEach((instance) =>
          window.CKEDITOR.instances[instance].destroy(true)
        );
      }
    };
  }, []);

  // Fetch existing data
  const fetchTestimonyData = async () => {
    try {
      const response = await axios.get(
        `https://admin.gosaviadvanceddentalclinic.com/api/getonetestimony/${id}`
      );
      if (response.data.success) {
        setTestimonyUser(response.data.data);
        if (window.CKEDITOR && window.CKEDITOR.instances.editor) {
          window.CKEDITOR.instances.editor.setData(
            response.data.data.description
          );
        }
      }
    } catch (error) {
      console.error("Error fetching Testimony data!", error);
      toast.error("Failed to load Testimony data.");
    }
  };

  useEffect(() => {
    if (editorLoaded) fetchTestimonyData();
  }, [id, editorLoaded]);

  useEffect(() => {
    if (editorLoaded && !window.CKEDITOR.instances.editor) {
      window.CKEDITOR.replace("editor");
    }
  }, [editorLoaded]);

  useEffect(() => {
    if (editorLoaded && window.CKEDITOR.instances.editor) {
      window.CKEDITOR.instances.editor.setData(Testimonyuser.description || "");
    }
  }, [Testimonyuser.description, editorLoaded]);

  // Set preview image if already available
  useEffect(() => {
    if (
      Testimonyuser.testimonyimage &&
      typeof Testimonyuser.testimonyimage === "string"
    ) {
      setPreviewImage(Testimonyuser.testimonyimage);
    }
  }, [Testimonyuser.testimonyimage]);

  // Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setTestimonyUser({ ...Testimonyuser, [name]: value });
  };

  // Handle image change
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/webp",
      ];
      const maxSize = 2 * 1024 * 1024; // 2MB

      // ✅ Type check
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }

      // ✅ Size check
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }

      // ✅ Optional: Dimension check (example: max 1920x1080)
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;

      img.onload = () => {
        const { width, height } = img;

        // Example check (adjust if needed)
        if (width > 800 || height > 800) {
          toast.error("Image dimensions should not exceed 800x800.");
          URL.revokeObjectURL(objectUrl); // Clean up
          return;
        }

        setSelectedImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };
  // Submit form
  const submitForm = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", Testimonyuser.name);
    formData.append("description", window.CKEDITOR.instances.editor.getData());
    if (selectedImage) {
      formData.append("testimonyimage", selectedImage);
    }

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatetestimony/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        toast.success("Data updated successfully!");
        navigate("/Testimony");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error updating the Testimony:", error);
      toast.error("Failed to update Testimony.");
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
      aria-modal="true"
    >
      <div className="modal-dialog">
        <form onSubmit={submitForm} encType="multipart/form-data">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit</h5>
              <Link to="/Testimony">
                <button type="button" className="close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  name="testimonyimage"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <br />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                    }}
                    />
                  )}
              </div>

              <div className="form-group">
                  <br/>
                <label>Description</label>
                <textarea id="editor"></textarea>
                <br />
              </div>

              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  value={Testimonyuser.name}
                  onChange={changeHandler}
                  className="form-control"
                  name="name"
                  required
                />
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Testimony">
                <button type="button" className="btn btn-secondary">
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export const HomeTestimonyView = () => {
  const [TestimonyUser, setTestimonyUser] = useState({
    name: "",
    description: "",
    testimonyimage: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const TestimonyData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonetestimony/${id}`
        );
        setTestimonyUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    TestimonyData();
  }, [id]);

  return (
    <div className="container-fluid admin-view">
      <div className="row arpi">
        <div className="col-lg-3 col-md-3 col-sm-12"></div>

        <div className="col-lg-7 col-md-7 col-sm-12 view-sec">
          <Link to="/Testimony" className="back-btn">
            <i className="fa-solid fa-arrow-left"></i> Back
          </Link>
          <br />
          <br />

          <h4>
            {TestimonyUser.name}{" "}
            <Link to={`/Testimony-edit/` + TestimonyUser.id}>
              <i className="fa-regular fa-pen-to-square"></i>
            </Link>
          </h4>
          <br />
          <p
            dangerouslySetInnerHTML={{ __html: TestimonyUser.description }}
          ></p>
          <br />
          <img
            src={TestimonyUser.testimonyimage}
            alt="Testimony"
            style={{ width: "100%", height: "500px" }}
          />
        </div>
      </div>
    </div>
  );
};

export const TestimonyHeaderEdit = () => {
  const [Testimonyuser, setTestimonyUser] = useState({
    heading: "",
    para: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setTestimonyUser({ ...Testimonyuser, [name]: value });
    // console.log(user);
  };

  useEffect(() => {
    const editData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getonetestimonytop/${id}`
        );
        // console.log(response.data);
        setTestimonyUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    editData();
  }, [id]);

  const submitForm = async (e) => {
    e.preventDefault();

    const formData = {
      heading: Testimonyuser.heading,
      para: Testimonyuser.para,
    };

    try {
      const response = await axios.put(
        `https://admin.gosaviadvanceddentalclinic.com/api/updatetestimonytop/${id}`,
        formData,
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.data.success) {
        setTestimonyUser(formData);
        toast.success("Data updated successfully!");
        navigate("/Testimony");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("There was an error!", error);
    }
  };

  return (
    <div
      className="modal fade show"
      id="update_heading"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      style={{
        display: "block",
        paddingRight: 18,
        marginTop: 90,
        paddingBottom: 50,
      }}
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={submitForm}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit
              </h5>
              <Link to="/Testimony">
                <button type="button" className="close" aria-label="Close">
                  <span aria-hidden="true">
                    <i className="fa-solid fa-xmark"></i>
                  </span>
                </button>
              </Link>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Heading</label>
                <input
                  type="text"
                  value={Testimonyuser.heading}
                  onChange={changeHandler}
                  className="form-control"
                  name="heading"
                />
                <br />
              </div>

              <div className="form-group">
                <label>Paragraph</label>
                <textarea
                  type="text"
                  value={Testimonyuser.para}
                  onChange={changeHandler}
                  className="form-control"
                  name="para"
                  rows={4}
                />
                <br />
              </div>
            </div>

            <div className="modal-footer">
              <Link to="/Testimony">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </Link>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
